import { queryDataExt } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getClassificationsWithConditions = async (
  whereClause,
  selectFields,
  sortFields
) => {
  return await queryDataExt(
    `${GlobalConfig.REACT_APP_API_CLASSIFICATION_URL}getWithConditions`,
    whereClause,
    selectFields,
    sortFields
  );
};